var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 257,
    height: 256,
    viewBox: "0 0 257 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_203_27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.5 1C199.195 1 256.5 57.6884 256.5 127.623C256.5 197.558 199.195 254.246 128.5 254.246C57.8048 254.246 0.5 197.558 0.5 127.623C0.5 57.6884 57.8048 1 128.5 1ZM187.245 69.5103C161.76 44.4421 121.445 43.4451 97.1119 67.5163C54.0757 110.09 66.7664 185.083 67.2913 188.065L67.3076 188.157C67.3076 188.157 145.49 201.973 189.26 158.673C213.593 134.602 212.729 94.5785 187.245 69.5103ZM143.186 75.2076L155.713 100.703L181.485 113.095L155.713 125.487L143.186 150.982L130.66 125.487L104.887 113.095L130.66 100.703L143.186 75.2076Z",
    fill: "#3F78D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_203_27"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapbox);
export default __webpack_public_path__ + "static/media/Mapbox.68044c21d45617990781430685715012.svg";
export { ForwardRef as ReactComponent };